export default __webpack_public_path__ + "static/media/room3-MASK-wood-rot27.d39a0048.png";